module.exports = __webpack_public_path__ + "static/media/README.2d48a517.md";